import { action, observable, computed, extendObservable, makeObservable } from 'mobx';
import _ from 'lodash';

import { headerStore } from './header.store';
import NewAppMasterStore from './new-application/new-app-master.store';
import { myAppsStore } from './my-apps.store';
import AppDetailStore from './app-detail.store';
import { userStore } from './user.store';
import { feedbackStore } from './feedback.store';
import { joyrideStore } from './joyride.store';
import { modalsStore } from './modals.store';
import { history } from 'fn-common-ui';
import { apiService } from '../services/api.service';

class MasterStore {

	constructor() {
		makeObservable(this);
		this.headerStore = headerStore;
		this.newAppMasterStore = new NewAppMasterStore(this);
		this.myAppsStore = myAppsStore;
		this.appDetailStore = new AppDetailStore(this);
		this.userStore = userStore;
		this.feedbackStore = feedbackStore;
		this.joyrideStore = joyrideStore;
		this.modalsStore = modalsStore;
		//console.log("testing for appDetailsStore = "+JSON.stringify(this.appDetailStore.appVersions))
	}

	getUser() {
		return this.userStore.user;
	}

	// ACTIONS

	@action createAlert(obj, id = history.location.pathname) {
		this.alerts.set(id, obj);
	}

	@action clearAlerts(id) {
		if(!id){
			this.alerts = observable.map();
		} else {
			this.alerts.delete(id);
		}
	}

	@action registerPage(id) {
		if (!this.loadMoreMultipliers[id]) {
			extendObservable(this.loadMoreMultipliers, {
				[id]: 1
			});
		}
	}

	@action deRegisterPage(id) {
		delete this.loadMoreMultipliers[id];
	}

	@action incrementPage(id) {
		this.loadMoreMultipliers[id]++;
	}

	@action resetPage(id) {
		this.loadMoreMultipliers[id] = 1;
	}

	/* FIXME: Moved the following functions to Master, because it interacts with
	2 stores, and needs to be kept carefully in sync.
	Currently, the version sidebar uses app-detail store, but the  page body
	uses new-application stores. In the future, we should look into simplifying
	the app version storage between the 2.*/
	@action selectAppVersion({versionNumber, saveId}) {
		this.appDetailStore.reviewsVisible = false;

		const versions = this.appDetailStore.appVersions.versions.slice();
		let index = undefined;
		if (saveId) {
			index = _.findIndex(versions, (version) => {
				return version.saveId === saveId;
			});
		} else {
			index = _.findIndex(versions, (version) => {
				return version.version_num === versionNumber;
			});
		}

		this.appDetailStore.selectedVersion = {
			versionIndex: index,
			versionNum: versionNumber,
			saveId: saveId
		}

		this.newAppMasterStore.storeAppInPartialSaveFormat(this.appDetailStore.appVersions, index);
	}

	downloadDeveloperChecklistFile() {
		if (this.appDetailStore.isReleased) {
			return apiService.downloadDeveloperChecklistFile({
				applicationIdentifier: this.appDetailStore.appVersions.saveId,
				versionNumber: this.appDetailStore.selectedVersion.versionNum
			});
		} else {
			return apiService.downloadDeveloperChecklistFile({
				applicationIdentifier: this.newAppMasterStore.newAppData.saveId
			});
		}
	}
	/*** end FIXME ***/

	// COMPUTEDS
	@computed get isLoggedIn() {
		return this.userStore.authentic_user;
	}

	// OBSERVABLES
	@observable alerts = observable.map();
	@observable isLoading = false;
	@observable loadMoreMultipliers = {};

}

export const masterStore = new MasterStore();
